var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.625,
    height: 23.625,
    viewBox: "0 0 23.625 23.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_497830",
    "data-name": "Path 497830",
    d: "M21,13.107A1.109,1.109,0,0,1,22.107,12h.738a1.109,1.109,0,0,1,1.107,1.107v.738a1.109,1.109,0,0,1-1.107,1.107h-.738A1.109,1.109,0,0,1,21,13.846Z",
    transform: "translate(-10.664 -6.094)",
    fill: "#356f92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497831",
    "data-name": "Path 497831",
    d: "M23.906,28.383H18V26.906h1.477v-4.43H18V21h4.43v5.906h1.477Z",
    transform: "translate(-9.141 -10.664)",
    fill: "#356f92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497832",
    "data-name": "Path 497832",
    d: "M11.813,0A11.813,11.813,0,1,0,23.625,11.813,11.816,11.816,0,0,0,11.813,0Zm0,21.41a9.6,9.6,0,1,1,9.6-9.6A9.6,9.6,0,0,1,11.813,21.41Z",
    fill: "#356f92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497833",
    "data-name": "Path 497833",
    d: "M0,0H23.625V23.625H0Z",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.935c439864e98107cd89aadf13bc5c5e.svg";
export { ForwardRef as ReactComponent };